export enum MeetingType {
  BOARD_MEETING = 'BOARD_MEETING',
  ANNUAL_GENERAL_MEETING = 'ANNUAL_GENERAL_MEETING',
  EXTRAORDINARY_GENERAL_MEETING = 'EXTRAORDINARY_GENERAL_MEETING',
  SHAREHOLDER_MEETING = 'SHAREHOLDER_MEETING',
  OTHER_MEETING = 'OTHER_MEETING',
}

export const allMeetingTypes = [
  {
    value: MeetingType.BOARD_MEETING,
    isGAType: false,
  },
  {
    value: MeetingType.ANNUAL_GENERAL_MEETING,
    isGAType: true,
  },
  {
    value: MeetingType.EXTRAORDINARY_GENERAL_MEETING,
    isGAType: true,
  },
  {
    value: MeetingType.SHAREHOLDER_MEETING,
    isGAType: true,
  },
  {
    value: MeetingType.OTHER_MEETING,
    isGAType: false,
  },
];
